/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageFragment} from '@amblique/contentful/app/contentful/fragments/page/base-page.fragment';
import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';
import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';
import {BaseBlogGridFragment} from '@amblique/contentful/app/contentful/fragments/blog-grid/base-blog-grid.fragment';
import {BaseBreadcrumbFragment} from '@amblique/contentful/app/contentful/fragments/breadcrumb/base-breadcrumb.fragment';
import {BaseCardFragment} from '@amblique/contentful/app/contentful/fragments/card/base-card.fragment';
import {BaseCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/base-carousel.fragment';
import {BaseContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/base-container.fragment';
import {BaseEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/base-embed-panel.fragment';
import {BaseFeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/base-feature-list.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseIconSetFragment} from '@amblique/contentful/app/contentful/fragments/icon-set/base-icon-set.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseSeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/base-seo.fragment';
import {BaseShowroomDetailsFragment} from '@amblique/contentful/app/contentful/fragments/showroom-details/base-showroom-details.fragment';
import {BaseSplitPanelDoubleImageBlockFragment} from '@amblique/contentful/app/contentful/fragments/split-panel-double-image-block/base-split-panel-double-image-block.fragment';
import {BaseTeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block/base-teaser-tile-block.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const PageFragment = gql`
  ${BaseAccordionFragment}
  ${BaseAccordionPanelFragment}
  ${BaseBlogFragment}
  ${BaseBlogGridFragment}
  ${BaseBreadcrumbFragment}
  ${BaseCardFragment}
  ${BaseCarouselFragment}
  ${BaseContainerFragment}
  ${BaseEmbedPanelFragment}
  ${BaseFeatureListFragment}
  ${BaseHeroBannerFragment}
  ${BaseIconSetFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseMediaCarouselFragment}
  ${BasePageFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseSeoFragment}
  ${BaseShowroomDetailsFragment}
  ${BaseSplitPanelDoubleImageBlockFragment}
  ${BaseTeaserTileBlockFragment}
  ${BaseVideoFragment}

  fragment PageFragment on Page {
    ...BasePageFragment

    mainRegionCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on AccordionPanel {
          ...BaseAccordionPanelFragment
        }
        ... on Blog {
          ...BaseBlogFragment
        }
        ... on BlogGrid {
          ...BaseBlogGridFragment
        }
        ... on Breadcrumb {
          ...BaseBreadcrumbFragment
        }
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on Container {
          ...BaseContainerFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on IconSet {
          ...BaseIconSetFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on Link {
          ...BaseLinkFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on ShowroomDetails {
          ...BaseShowroomDetailsFragment
        }
        ... on SplitPanelDoubleImageBlock {
          ...BaseSplitPanelDoubleImageBlockFragment
        }
        ... on TeaserTileBlock {
          ...BaseTeaserTileBlockFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
    seo {
      ...BaseSeoFragment
    }
  }
`;
